<nav class="simple-navigation" appAccordion>
  @for (menuitem of menuItems(); track menuitem.state) {
    <!-- Regular Navigation Item -->
    @if (menuitem.type === 'link' && menuitem.visible !== false) {
      <div class="nav-item">
        <a class="nav-link"
           [id]="'nav-' + menuitem.state + '-link'"
           [class.active]="isActive('/' + menuitem.state)"
           [routerLink]="['/', menuitem.state]"
           (click)="onMenuItemClick($event)">
          <i class="nav-icon {{ menuitem.icon }}"></i>
          <span class="nav-text">{{ menuitem.name | translate }}</span>
          @for (badge of menuitem.badge; track badge.value) {
            <span class="badge">{{ badge.value }}</span>
          }
        </a>
      </div>
    }

    <!-- External Link -->
    @if (menuitem.type === 'extLink' && menuitem.visible !== false) {
      <div class="nav-item">
        <a class="nav-link"
           [id]="'nav-' + menuitem.state + '-link'"
           href="{{menuitem.state}}"
           (click)="onMenuItemClick($event, true)">
          <i class="nav-icon {{ menuitem.icon }}"></i>
          <span class="nav-text">{{ menuitem.name | translate }}</span>
          @for (badge of menuitem.badge; track badge.value) {
            <span class="badge">{{ badge.value }}</span>
          }
        </a>
      </div>
    }

    <!-- External Tab Link -->
    @if (menuitem.type === 'extTabLink' && menuitem.visible !== false) {
      <div class="nav-item">
        <a class="nav-link"
           [id]="'nav-' + menuitem.state + '-link'"
           href="{{menuitem.state}}"
           target="_blank"
           (click)="onMenuItemClick($event, true)">
          <i class="nav-icon {{ menuitem.icon }}"></i>
          <span class="nav-text">{{ menuitem.name | translate }}</span>
          @for (badge of menuitem.badge; track badge.value) {
            <span class="badge">{{ badge.value }}</span>
          }
        </a>
      </div>
    }

    <!-- Submenu Parent -->
    @if (menuitem.type === 'sub' && menuitem.visible !== false) {
      <div class="nav-item"
           appAccordionLink
           group="{{menuitem.state}}">
        <!-- Dropdown toggle -->
        <a class="nav-link" [id]="'nav-' + menuitem.state + '-toggle'" appAccordionToggle href="javascript:;">
          <i class="nav-icon {{ menuitem.icon }}"></i>
          <span class="nav-text">{{ menuitem.name | translate }}</span>
          @for (badge of menuitem.badge; track badge.value) {
            <span class="badge">{{ badge.value }}</span>
          }
          <i class="dropdown-arrow material-icons">keyboard_arrow_down</i>
        </a>

        <!-- Submenu Items -->
        <div class="dropdown-menu">
          @for (childitem of menuitem.children; track childitem.state) {
            <a [routerLink]="childitem.routerLink || ['/', menuitem.state, childitem.state]"
               [id]="'nav-' + menuitem.state + '-' + childitem.state + '-link'"
               class="dropdown-item"
               [class.active]="isActive(childitem.activeMatch || ('/' + menuitem.state + '/' + childitem.state))"
               (click)="onMenuItemClick($event)">
              <span>{{ childitem.name | translate }}</span>
              @for (badge of childitem.badge; track badge.value) {
                <span class="badge">{{ badge.value }}</span>
              }
            </a>
          }
        </div>
      </div>
    }

    <!-- Navigation Divider -->
    @if (menuitem.type === 'divider') {
      <div class="divider"></div>
    }

    <!-- Navigation Section Title -->
    @if (menuitem.type === 'title') {
      <div class="section-title">
        {{ menuitem.name | translate }}
      </div>
    }
  }
</nav>